import React from 'react';
export function AnalyticsIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M6 13h2v5H6v-5zm7-3h-2v8h2v-8zm3-4h2v12h-2V6z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 22V2h22v20H1zm2-2h18V4H3v16z"
  }));
}